// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Forum_mainContainer__3gzGd","shadow":"Forum_shadow__2Fkce","card":"Forum_card__1nSSq","cardlist":"Forum_cardlist__3PIQV"};